import { Injectable } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CustomerReportingUsageWarningService {
  private _hideWarning = new BehaviorSubject<boolean>(false);
  private routerSubscription: Subscription;

  public hideWarning$ = this._hideWarning.asObservable();

  constructor(private router: Router) {
    this.routerSubscription = this.router.events
      .pipe(
        filter(
          (event): event is NavigationEnd => event instanceof NavigationEnd,
        ),
      )
      .subscribe((event: NavigationEnd) => {
        if (!event.urlAfterRedirects.includes('/customer-reporting')) {
          this._hideWarning.next(false);
        }
      });
  }

  get currentWarning(): boolean {
    return !!this._hideWarning.value;
  }

  setHideWarning(value: boolean): void {
    this._hideWarning.next(value);
  }
}
